module.exports = __webpack_public_path__ + "static/img/建筑智能化_中央空调系统1@2x.02bcff4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/建筑智能化_中央空调系统1@2x.jpg
// module id = 16MY
// module chunks = 1